import { createHttpLink } from '@apollo/client';

const GRAPHQL_URL = process.env.REACT_APP_GRAPHQL_URL || '/api/graphql';

export const httpLink = createHttpLink({
  uri: GRAPHQL_URL,
});
